import { CircularProgress, CircularProgressProps } from '@mui/material';

export function MuiCircularProgress(props: CircularProgressProps) {
  return <CircularProgress {...props} />;
}
